import { getGetPagedAction } from "../generic/paged.actions";
import CONFIG from "./registrationDocument.config";
export var getPaged = getGetPagedAction({
    entityName: CONFIG.ENTITY_NAME,
});
